<template>
    <b-row>
        <b-col cols="12" class="mb-3">
            <h3>งานเพิ่มเติม</h3>
        </b-col>
        <b-col cols="12">
            <b-table
                :items="listItemJobAddOn"
                :fields="fields"
                responsive
                class="scroll-bar-mkt"
            >
                <template #cell(index)="row">
                    {{ row.index+1 }}
                </template>
                <template #cell(name)="row">
                    {{ row.item.name }}
                </template>
                <template #cell(price)="row">
                    <h3>{{ Number(row.item.price) | number }} บาท</h3>
                </template>
                <template #cell(status)="row">
                    <b-badge
                        :variant="getStatusBadgeVariant(row.item.status)"
                        class="my-2"
                    >
                        {{ getStatusBadgeText(row.item.status) }}
                    </b-badge>
                </template>
            </b-table>
        </b-col>
    </b-row>
</template>

<script>
import jobServices from "@/api/job.service.js";
import { getStatusBadgeVariant, getStatusBadgeText } from "@/util/constants.js"

export default {
    data(){
        return{
            getStatusBadgeVariant,
            getStatusBadgeText,
            fields: [
                {
                    key: "index",
                    label: "#",
                    class: 'text-left h5'
                },
                {
                    key: "name",
                    label: "รายละเอียด",
                    class: 'text-left h5'
                },
                {
                    key: "price",
                    label: "ราคา",
                    class: 'text-center h5'
                },
                {
                    key: "status",
                    label: "สถานะ",
                    class: 'text-center h5'
                }
            ],
            listItemJobAddOn: []
        }
    },
    mounted(){
        this.getJobAddOn();
    },
    methods:{
        async getJobAddOn(){
            const { data } = await jobServices.getJobAddOn({job_id: this.$route.params.id})
    
            if( data.data ){
                this.listItemJobAddOn = data.data.jobAdditional
            }
        }   
    }
}
</script>
